import { Box, Container, Stack } from "@mui/material";

const list = [
  {
    productName: "Atomic Habit",
    productType: "Self growth",
    meta: "Weekly focus",
    description: "A practical reading path for building cleaner daily routines.",
    imagePath: "/img/events1.avif",
  },
  {
    productName: "Reader meetups",
    productType: "Community",
    meta: "Saturday club",
    description: "Join reader circles, author talks, and small book discussions.",
    imagePath: "/img/events2.avif",
  },
  {
    productName: "Biography picks",
    productType: "Editors choice",
    meta: "Curated list",
    description: "Real stories selected for ambitious readers and makers.",
    imagePath: "/img/events4.jpg",
  },
];

export default function Events() {
  return (
    <div className={"events-frame"}>
      <Container>
        <Stack className={"events-main"}>
          <Stack className={"section-heading"}>
            <span className={"section-kicker"}>Book culture</span>
            <Box className={"category-title"}>Events & Highlights</Box>
            <p>Small editorial cards to keep the homepage alive and useful.</p>
          </Stack>

          <Stack className={"events-info"}>
            {list.map((item) => (
              <article className={"events-info-frame"} key={item.productName}>
                <img
                  src={item.imagePath}
                  alt=""
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                  }}
                />
                <div className={"events-desc"}>
                  <div className={"events-tag-row"}>
                    <span>{item.productType}</span>
                    <em>{item.meta}</em>
                  </div>
                  <strong>{item.productName}</strong>
                  <p>{item.description}</p>
                  <button type="button">Explore story</button>
                </div>
              </article>
            ))}
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}
